module.exports = __webpack_public_path__ + "img/Error404.9aca0916.gif";